import { render, staticRenderFns } from "./BlogTabs.vue?vue&type=template&id=d15f3e56&"
import script from "./BlogTabs.vue?vue&type=script&lang=js&"
export * from "./BlogTabs.vue?vue&type=script&lang=js&"
import style0 from "./BlogTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports